<template>
  <CRow>
    <template v-if="message.status">
      <h2 class="h1 mb-5" :class="`text-${message.status}`">{{ message.message }}</h2>
    </template>
    <template v-else>
      <CCol sm="12">
        <h2 class="h1 mb-3 pt-5">{{ $t('auth.businessProfile.header2.witch-business') }}</h2>
      </CCol>
      <CCol md="10">
        <CRow class="business my-3">
          <CCol sm="12" v-for="(item, i) in business" :key="i">
            <input type="radio" name="business" :value="item.value" v-model="value" :id="item.value" class="d-none" />
            <label :for="item.value" class="business__item mb-3 p-sm-3 py-sm-4 w-100 label-border" @click="businessSelected = false">
              <CRow>
                <CCol sm="4" md="3" class="business__img d-flex align-items-center">
                  <CIcon :name="item.icon" size="custom-size" :height="45" viewBox="0 0 32 32" />
                </CCol>
                <CCol sm="8" md="9" class="business__body">
                  <p class="text-right business__checked"><i class="cil-check-alt icon-custom-size"></i></p>
                  <h3 class="business__title font-2xl pt-2">{{ $t(item.label) }}</h3>
                  <!-- <p class="business__description mb-0 font-3lg">
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Nemo incidunt architecto temporibus. Aut, quidem totam.
                  </p> -->
                </CCol>
              </CRow>
            </label>
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12" md="12">
        <CButton class="mr-5" @click="() => $router.push({ name: 'Login' })">
          <CIcon name="cilArrowLeft" size="custom-size" :height="25" viewBox="0 0 32 32" />
          {{ $t('auth.newRegister.button.backToLogin') }}
        </CButton>
        <CButton type="submit" :disabled="businessSelected" @click="next()" color="primary" class="px-5">
          {{ $t('auth.newRegister.businessProfile.button.next') }}
        </CButton>
      </CCol>
    </template>
  </CRow>
</template>

<script>
import services from '@/services.js'

const icons = {
  Company: 'cilBuilding',
  Agency: 'cilBriefcase',
  IndividualFreelancer: 'cilUser',
}

export default {
  name: 'BusinessProfile',
  data() {
    return {
      message: {
        state: null,
        message: '',
      },
      IdAccount: null,
      value: '',
      businessSelected: true,
      business: [],
    }
  },
  mounted() {
    let newRegister = this.$store.state.auth.newRegister

    if (!newRegister.userId || !newRegister.organizationId) {
      this.$router.push({ name: 'Login' })
    }

    this.IdAccount = newRegister.organizationId
    this.getBusinessProfiles()
  },
  methods: {
    getBusinessProfiles() {
      this.message = []
      services
        .getBusinessProfileList()
        .then((response) => {
          this.business = response.data
          this.business = this.business.map((elm) => {
            return {
              value: elm.value,
              label: 'settings.organization.formOrganization.form.options.businessProfile.' + elm.label,
              icon: icons[elm.label] || cilBuilding,
            }
          })
        })
        .catch((err) => {
          this.message.push(err.response)
        })
    },

    next() {
      const obj = [
        {
          op: 'replace',
          path: '/BusinessProfile',
          value: Number(this.value),
          operationType: 1,
        },
      ]

      services
        .updateBusinessProfile(this.IdAccount, obj)
        .then(() => {
          this.message = {
            status: 'sucess',
            message: 'Just one more step!',
          }

          setTimeout(() => {
            this.$router.push({ name: 'ConfirmRegister' })
          }, 1000)
        })
        .catch(() => {
          this.message = {
            status: 'danger',
            message: 'Try again!',
          }

          setTimeout(() => {
            this.message = {}
          }, 1000)
        })
    },
  },
  computed: {
    hasBusiness() {
      return this.businessSelected == null ? true : false
    },
  },
}
</script>

<style lang="scss" scope>
.label-border {
  border: 1px solid $gray-300 !important;
}
.business {
  input:checked + .business__item {
    background: var(--white);
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.1);

    .business__checked {
      opacity: 1;
    }

    i {
      color: var(--primary);
    }
  }

  &__item {
    cursor: pointer;
    border: 1px solid var(--white);
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.03);
    transition: all 300ms ease-in-out;

    &:hover {
      background: var(--white);
      box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.1);
    }
  }

  &__checked {
    opacity: 0;
    position: absolute;
    right: 20px;
    top: -5px;
    font-size: 30px;
    color: var(--primary);

    @media only screen and (min-width: 1024px) {
      right: 20px;
      top: -15px;
    }
  }

  &__img {
    text-align: center;
    i {
      font-size: 80px;
      margin: 0 auto;
      transition: all 300ms ease-in-out;
    }
  }

  &__description {
    line-height: 1.5em;
    font-size: 15px;
    color: #7f889a; //TODO falta mapear a cor

    @media only screen and (min-width: 1024px) {
      font-size: 19px;
    }
  }
}
</style>
